/*
 * @Author: fz
 * @Date: 2021-07-29 10:15:22
 * @LastEditTime: 2021-08-05 15:24:51
 * @LastEditors: yuanjiaheng
 * @Description: 自动配载设置 -- api
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BUSI_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB
} = e6ModuleOrderWaybillProcessApi;
// 获取列表数据
export function getStowageList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/queryByPage`,
    method: "post",
    data
  });
}

// 删除
export function deleteStowageInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/remove`,
    method: "post",
    data
  });
}

// 获取更改记录列表数据
export function getStowageHistoryList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/queryHistoryByPage`,
    method: "post",
    data
  });
}

//查询业务类型
export function getbusinessTypesData() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/flowBusinessType/getUsedBusinessTypeList`,
    method: "get"
  });
}
//新增修改接口
export function stowageRulesaveOrUpdate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/saveOrUpdate`,
    method: "post",
    data
  });
}
//规则名称唯一性校验
export function stowageRuleName(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/checkName`,
    method: "get",
    params
  });
}
//收发货区域下拉
export function getstowageArea(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}
//查询规则详情
export function stowageRuleDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/stowageRule/detail/${params}`,
    method: "get"
  });
}
